import {
  Box,
  Checkbox, Collapse as ChakraCollapse, Editable, EditableInput, EditablePreview, Text,
} from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import Collapse from '../../../Core/Collapse';
import useUpdateField from '../useUpdateField';

const RequiredOption = ({ field, defaultMessage }) => {
  const collapse = useRef();
  const [required, setRequired] = useUpdateField(field, 'schema.flags.presence');
  const [customMessage, setCustomMessage] = useUpdateField(field, 'schema.preferences.messages.string-empty.value');
  const [bold, setBold] = useUpdateField(field, 'schema.preferences.messages.string-empty.bold');

  const handleRequestCM = (e) => {
    if (e.target.checked) {
      console.log(defaultMessage);
      setCustomMessage(defaultMessage);
      setBold(defaultMessage.includes('<b>{#label}</b>'));
    } else {
      setCustomMessage('');
    }
  };

  useEffect(() => {
    collapse.current.close();
  }, [field.key]);

  return (
    <Collapse
      ref={collapse}
      mt="8px"
      title={(
        <Checkbox
          size="sm"
          isChecked={required === 'required'}
          onChange={(e) => setRequired(e.target.checked ? 'required' : 'optional')}
        >
          Required
        </Checkbox>
)}
    >
      <Box p="2" mt="1" border="1px solid" borderColor="gray.200">
        <Checkbox size="sm" isChecked={!!customMessage} onChange={handleRequestCM}>Use custom messsage</Checkbox>
        <ChakraCollapse in={!!customMessage}>
          <Text mt="2">
            Error message:
          </Text>
          <Text color="gray.400" fontSize="xs">
            You can add
            {' '}
            <b>{'{#label}'}</b>
            {' '}
            to use the label on the message
          </Text>
          <Editable
            my="2"
            value={customMessage}
            fontFamily="monospace"
            fontSize="sm"
            onChange={setCustomMessage}
          >
            <EditablePreview w="100%" bg="gray.100" px="3px" />
            <EditableInput px="0" mx="3px" width="calc(100% - 6px)" />
          </Editable>
          <Checkbox
            size="sm"
            isChecked={bold}
            onChange={(e) => setBold(e.target.checked)}
          >
            bold
          </Checkbox>
        </ChakraCollapse>
      </Box>

    </Collapse>
  );
};
export default RequiredOption;
